import { toNumber } from "#/lib/formatters";
import { useHyperAccount } from "./use-hyperliquid-account";
import { useUnifiedBalance } from "./use-unified-balance";

/**
 * The user's trading balance (USD) — the equity figure that rises when a
 * bridge deposit credits the account. Equity = perp positions MTM + free spot
 * for unified / dexAbstraction accounts; perp-only for default accounts (see
 * ACCOUNT.md → Balance display rules).
 *
 * Single source of truth shared by `useNeedsDepositToTrading` and the deposit
 * dialog's arrival detection (`stores/pending-deposit.ts`).
 */
export function useTradingBalance(): number {
	const { accountState } = useHyperAccount();
	const { isUnified, isDexAbstraction, spotUsdc, spotUsdcHold } =
		useUnifiedBalance();

	const perpAccountValue = toNumber(
		accountState?.marginSummary?.accountValue ??
			accountState?.crossMarginSummary.accountValue,
	);
	return isUnified || isDexAbstraction
		? perpAccountValue + spotUsdc - spotUsdcHold
		: perpAccountValue;
}
